import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Box, Typography } from '@material-ui/core';

import { BusinessBookDemoButton } from 'src/components/BusinessBookDemoButton';
import { ToolTypeCIP } from 'src/assets/icons/ToolTypeCIP';
import { useStyles } from './useStyles';

export const BookDemoPanel = ({ className, onClick, userAllowedToBookDemo }) => {
  const styles = useStyles();

  return (
    <Box className={cx(styles.root, className)}>
      <Typography className={styles.badge}>Business Plan feature</Typography>
      <ToolTypeCIP className={styles.img} />
      <Typography className={styles.title}>Create Custom Scoring AI</Typography>
      <Typography className={styles.description}>
        Create models <b>trained</b> on your best performing marketing campaigns.
      </Typography>

      <BusinessBookDemoButton
        className={styles.button}
        onClick={onClick}
        canBook={userAllowedToBookDemo}
      />
    </Box>
  );
};

BookDemoPanel.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  userAllowedToBookDemo: PropTypes.bool,
};
BookDemoPanel.defaultProps = {
  className: '',
  userAllowedToBookDemo: false,
};
